export const maximumNumber = 9_007_199_254_740_991;

export const emptyListData = [
  [],
  {
    pageSize: 0,
    totalCount: 0,
    pageNumber: 1,
    nextPage: null,
    prevPage: null,
    lastPage: null,
  },
];
